import React, { useEffect, useContext } from "react";
import { connect } from "react-redux";
import { Context } from "context/context";
import { Transition } from "@headlessui/react";
import SideBarContent from "./sidebar-content";
import userActions from "redux/modules/user/actions";
import { useHistory } from "react-router-dom";
import parseUrl from "parse-url";
import { useDialogHook } from "utils/customhooks";
import ConfirmModal from "components/confirm/confirm";

function SideBar({ routeName, user, setUserData }) {
  const confirm = useDialogHook(ConfirmModal);
  const { mobileSidebar, setMobileSidebar, setCampaign, setSelectedTab } =
    useContext(Context);
  const { http, localstorage } = global.services;
  const history = useHistory();

  const handleLogout = () => {
    confirm(
      {
        title: "Logout",
        buttonText: "YES, LOGOUT",
        description: "Are you sure you want to logout?",
      },
      (result) => {
        if (result) {
          proceedLogout();
        }
      }
    );
  };

  const proceedLogout = async () => {
    try {
      const parts = parseUrl(window.location.href);
      const pathname = parts.pathname || "";
      const search = parts.search || "";
      const hash = parts.hash || "";

      await http.post("auth/logout");
      setMobileSidebar(false); // Close sidebar
      localstorage.remove("user_data"); // Remove user data on storage
      setUserData(null); // Remove user data on redux
      setCampaign({});
      setSelectedTab("basic");
      history.push(`${pathname + search + hash}`); // Redirect to current page
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (mobileSidebar) setMobileSidebar(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeName]);

  return (
    <>
      <Transition
        show={mobileSidebar}
        enter="transition ease-in-out duration-300 transform"
        enterFrom="translate-x-full"
        enterTo="translate-x-0"
        leave="transition ease-in-out duration-300 transform"
        leaveFrom="translate-x-0"
        leaveTo="translate-x-full"
        className={
          "lg:hidden z-30 max-w-screen fixed left-0 right-0 top-0 bottom-0 sidebar h-screen  overflow-y-auto overflow-x-hidden  xl:static text-white bg-primary custom-scroll"
        }
      >
        <SideBarContent
          user={user}
          routeName={routeName}
          onLogout={handleLogout}
        />
      </Transition>
      <div className="hidden lg:block site-sidabar bg-primary fixed left-0 top-0 right-0 bottom-0 sidebar h-screen overflow-y-auto overflow-x-hidden lg:static text-white bg-gray-700 custom-scroll">
        <SideBarContent
          user={user}
          routeName={routeName}
          onLogout={handleLogout}
        />
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUserData: (params) => {
      dispatch(userActions.setUserData(params));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
